"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ursaPadding = exports.getButtonPadding = void 0;
var _designTokens = require("@smartsheet/design-tokens");
var _mapButtonAppearance = require("./mapButtonAppearance");
const ursaPadding = {
  xsmall: _designTokens.space.space10,
  small: _designTokens.space.space20,
  medium: _designTokens.space.space30,
  large: _designTokens.space.space40
};
exports.ursaPadding = ursaPadding;
const getButtonPadding = _ref => {
  let {
    hasOnlyIcons,
    hasNoIcons,
    appearance,
    size,
    themeMode
  } = _ref;
  // If there's only icons, don't add any padding
  if (hasOnlyIcons || appearance === "link") {
    // 0 is important; some browsers have a user agent style with padding that we don't want
    return "0";
  }
  const actualAppearance = (0, _mapButtonAppearance.mapButtonAppearance)(appearance, themeMode);
  switch (actualAppearance) {
    // For Lodestar buttons.
    case "borderless":
      return `0 ${_designTokens.space.space10}`;
    case "primary":
    case "secondary":
    case "destructive":
    case "secondary-destructive":
    case "share":
      if (hasNoIcons) {
        return `0 ${_designTokens.space.space50}`;
      }
      return `0 ${_designTokens.space.space10}`;

    // For Ursa buttons.
    case "primary-filled":
    case "primary-empty":
    case "secondary-filled":
    case "secondary-outlined":
    case "secondary-empty":
    case "canvas-filled":
    case "canvas-empty":
    case "destructive-filled":
    case "destructive-empty":
      if (hasNoIcons) {
        return `0 ${ursaPadding[size]}`;
      } else {
        return `0`;
      }
  }
};
exports.getButtonPadding = getButtonPadding;
//# sourceMappingURL=getButtonPadding.js.map